import React from 'react';
import styled from 'styled-components';
import {Link} from 'react-router-dom'; // Assuming you use react-router for navigation
import {Fade} from 'react-awesome-reveal'; // Import Fade animation

// --- DATA STRUCTURE ---
// Moving data out of the component makes it easier to manage and update.
const locationsData = [
    {
        state: 'Florida',
        description: '',
        image: '/florida.png', // Replace with your image path
        slug: 'florida'
    },
    {
        state: 'New York',
        description: '',
        image: '/new-york-state.png', // Replace with your image path
        slug: 'new-york'
    },
    {
        state: 'New Jersey',
        description: '',
        image: '/new-jersey.png', // Replace with your image path
        slug: 'new-jersey'
    },
    {
        state: 'Texas',
        description: 'Proudly serving families in the Dallas-Fort Worth and Houston areas.',
        image: '/texas.png', // Replace with your image path
        slug: 'texas'
    },
];


// --- STYLED COMPONENTS (Updated) ---

// MODIFIED: Header now matches the Services page for consistency.
const PageHeader = styled.div`
    background-image: linear-gradient(rgba(42, 125, 225, 0.75), rgba(42, 125, 225, 0.75)), url('/united-states.png');
    /* NOTE: You'll need to create a suitable banner image like 'locations-banner.jpg' */
    background-size: cover;
    background-position: center;
    padding: 8rem 2rem; /* Adjusted padding slightly */
    text-align: center;
`;

// MODIFIED: Text styles now match the Services page.
const PageTitle = styled.h1`
    font-size: 3rem;
    color: #fff;
    margin-bottom: 1rem;
`;

const PageSubtitle = styled.p`
    font-size: 1.2rem;
    color: #fff;
    max-width: 600px;
    margin: 0 auto;
`;

// MODIFIED: Grid container remains similar but will hold more complex cards.
const LocationsContainer = styled.section`
    padding: 4rem 2rem;
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 2.5rem;
`;

// NEW: A wrapper for the card to handle the link styling.
const CardLink = styled(Link)`
    text-decoration: none;
    color: inherit;
    display: flex; /* Ensures the card inside fills the link area */
`;

// MODIFIED: The LocationCard is now much more visual and detailed.
const LocationCard = styled.div`
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.07);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    overflow: hidden; /* Keeps the image corners rounded */
    display: flex;
    flex-direction: column;
    width: 100%;

    &:hover {
        transform: translateY(-8px);
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
    }
`;

// NEW: Container for the state image.
const LocationImage = styled.div`
    height: 300px;
    background-image: url(${props => props.src});
    background-size: cover;
    background-position: center;
`;

// NEW: A content wrapper for padding and text layout.
const CardContent = styled.div`
    padding: 1.5rem 2rem 2rem;
    text-align: left;
    flex-grow: 1; /* Allows content to push button down */
    display: flex;
    flex-direction: column;
`;

// MODIFIED: StateName styling adjusted slightly.
const StateName = styled.h2`
    font-size: 1.8rem;
    color: #2a7de1;
    margin-bottom: 0.5rem;
`;

// NEW: Description paragraph.
const Description = styled.p`
    font-size: 1rem;
    line-height: 1.6;
    color: #555;
    margin-bottom: 1.5rem;
    flex-grow: 1; /* Pushes button to the bottom if cards have different text lengths */
`;

// NEW: A clear call-to-action button.
const DetailsButton = styled.div`
    display: inline-block;
    background-color: #2a7de1;
    color: #fff;
    padding: 0.75rem 1.5rem;
    border-radius: 5px;
    text-align: center;
    font-weight: 600;
    transition: background-color 0.2s ease;
    align-self: flex-start; /* Aligns button to the left */

    &:hover {
        background-color: #1e63b3;
    }
`;

// --- REACT COMPONENT (Updated) ---

const Locations = () => {
    return (
        <>
            <PageHeader>
                <PageTitle>Our Service Areas</PageTitle>
                <PageSubtitle>
                    We are proud to partner with families and communities across the nation. Find a location near you.
                </PageSubtitle>
            </PageHeader>

            <LocationsContainer>
                {/* Dynamically render cards from the data array */}
                {locationsData.map((location, index) => (
                    // Wrap each CardLink with Fade component
                    <Fade key={location.state} triggerOnce duration={1000} delay={index * 150}>

                        <CardLink to={`/contact?location=${location.slug}`}>
                            <LocationCard>
                                <LocationImage src={location.image}/>
                                <CardContent>
                                    <StateName>{location.state}</StateName>
                                    <Description>{location.description}</Description>
                                    <DetailsButton>Learn More</DetailsButton>
                                </CardContent>
                            </LocationCard>
                        </CardLink>
                    </Fade>
                ))}
            </LocationsContainer>
        </>
    );
};

export default Locations;